'use strict';
import * as $j_io$002egithub$002eiltotore$002eiron$002e$002dRuntime$002dConstraint from "./io.github.iltotore.iron.-Runtime-Constraint.js";
import * as $j_io$002egithub$002eiltotore$002eiron$002epackage$0024package$0024 from "./io.github.iltotore.iron.package$package$.js";
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Ldev_cheleb_scalamigen_Defaultable$given\uff3fDefaultable\uff3fIronType$() {
}
export { $c_Ldev_cheleb_scalamigen_Defaultable$given\uff3fDefaultable\uff3fIronType$ as $c_Ldev_cheleb_scalamigen_Defaultable$given\uff3fDefaultable\uff3fIronType$ };
$p = $c_Ldev_cheleb_scalamigen_Defaultable$given\uff3fDefaultable\uff3fIronType$.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Ldev_cheleb_scalamigen_Defaultable$given\uff3fDefaultable\uff3fIronType$;
/** @constructor */
function $h_Ldev_cheleb_scalamigen_Defaultable$given\uff3fDefaultable\uff3fIronType$() {
}
export { $h_Ldev_cheleb_scalamigen_Defaultable$given\uff3fDefaultable\uff3fIronType$ as $h_Ldev_cheleb_scalamigen_Defaultable$given\uff3fDefaultable\uff3fIronType$ };
$h_Ldev_cheleb_scalamigen_Defaultable$given\uff3fDefaultable\uff3fIronType$.prototype = $p;
$p.Tu = (function() {
  return (+$j_io$002egithub$002eiltotore$002eiron$002epackage$0024package$0024.$m_Lio_github_iltotore_iron_package$package$().PV(1.0, new $j_io$002egithub$002eiltotore$002eiron$002e$002dRuntime$002dConstraint.$c_Lio_github_iltotore_iron_RuntimeConstraint(new $j_java$002elang$002e$002dObject.$c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$1$3) => ((+_$1$3) > 0.0))), "Should be strictly positive")));
});
$p.eu = (function() {
  return this.Tu();
});
var $d_Ldev_cheleb_scalamigen_Defaultable$given\uff3fDefaultable\uff3fIronType$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Ldev_cheleb_scalamigen_Defaultable$given\uff3fDefaultable\uff3fIronType$, "dev.cheleb.scalamigen.Defaultable$given_Defaultable_IronType$", ({
  iU: 1,
  aR: 1
}));
export { $d_Ldev_cheleb_scalamigen_Defaultable$given\uff3fDefaultable\uff3fIronType$ as $d_Ldev_cheleb_scalamigen_Defaultable$given\uff3fDefaultable\uff3fIronType$ };
var $n_Ldev_cheleb_scalamigen_Defaultable$given\uff3fDefaultable\uff3fIronType$;
function $m_Ldev_cheleb_scalamigen_Defaultable$given\uff3fDefaultable\uff3fIronType$() {
  if ((!$n_Ldev_cheleb_scalamigen_Defaultable$given\uff3fDefaultable\uff3fIronType$)) {
    $n_Ldev_cheleb_scalamigen_Defaultable$given\uff3fDefaultable\uff3fIronType$ = new $c_Ldev_cheleb_scalamigen_Defaultable$given\uff3fDefaultable\uff3fIronType$();
  }
  return $n_Ldev_cheleb_scalamigen_Defaultable$given\uff3fDefaultable\uff3fIronType$;
}
export { $m_Ldev_cheleb_scalamigen_Defaultable$given\uff3fDefaultable\uff3fIronType$ as $m_Ldev_cheleb_scalamigen_Defaultable$given\uff3fDefaultable\uff3fIronType$ };
